import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import { ACTIVATION_ROOT_ROUTE } from "app/pages/activation/routing/constants";
import {
    BENCHMARK_TRACKER_ROOT_ROUTE,
    BENCHMARK_TRACKER_ROOT_URL,
    CONFIG_ID,
    SECONDARY_BAR_TYPE,
} from "app/pages/benchmark-tracker";
import { BenchmarkTrackerRoot } from "app/pages/benchmark-tracker/root";

import { reportConfig } from "./report";

const PACKAGE_NAME = "digitalsuite";

export const benchmarkTrackerConfig: RouterStateConfig = {
    [BENCHMARK_TRACKER_ROOT_ROUTE]: {
        url: BENCHMARK_TRACKER_ROOT_URL,
        component: BenchmarkTrackerRoot,
        parent: ACTIVATION_ROOT_ROUTE,
        packageName: PACKAGE_NAME,
        configId: CONFIG_ID,
        configIdDeps: ["WebAnalysis", "MobileWeb", "MobileWebWorldwide"],
        secondaryBarType: SECONDARY_BAR_TYPE,
        hideFromRecents: true,
    },
    ...reportConfig,
};
